import { setIsWhiteLabel } from '@/context/display';
import { store } from '@/context/store';

export function setInitialIsWhiteLabel(partnerIsWhiteLabel: boolean): void {
    const { isWhiteLabel } = store.getState().displayReducer;
    if (isWhiteLabel !== partnerIsWhiteLabel) {
        store.dispatch(setIsWhiteLabel(partnerIsWhiteLabel));
    }
}
